import { SEGMENT } from "gatsby-env-variables"

import Datadog from "@garantidos/utils/js/datadog"

import { configure } from "@mobi/ds"
import analytics from "@mobi/libraries/analytics"

// Styles
import "styles/index.scss"
import trackings from "tracking"

// Contexts
import { SimulationProvider } from "./src/contexts/simulation"

analytics.setup({
  segmentId: SEGMENT,
  trackings,
})

console.log("Datadog.init: Started")
Datadog.init()
console.log("Datadog.init: Finished")

configure({
  originFonts: "intern",
  fonts: {
    ItauText: [300, 400, 700, 900],
    ItauDisplay: [300, 700, 900],
  },
})

export const wrapRootElement = ({ element }) => (
  <SimulationProvider>{element}</SimulationProvider>
)
